import React from 'react';
import { useSelector } from 'react-redux';
import { UIRootState } from 'ui/store';
import { translate } from 'game/translate';

interface SettingsButtonProps {
  type: 'main' | 'secondary';
  onClick: () => void;
  isSelected?: boolean;
}

export const SettingsButton: React.FC<SettingsButtonProps> = ({ onClick, type, isSelected }) => {
  const indicators = useSelector((state: UIRootState) => state.gameUI.indicators);

  return (
    <div id="closing-ignore-el" style={isSelected ? { background: 'rgba(31, 31, 31, 0.40)' } : {}} className={`mission-button settings-button--${type} w-100 d-flex justify-content-center ${type === 'secondary' ? 'side-bar-button--secondary-wrapper' : 'side-bar-button--wrapper'}`}>
      <button 
        id="settingsButton" 
        onClick={onClick}
        className={`${type === 'secondary' ? 'side-bar-button side-bar-button--secondary' : 'side-bar-button'} position-relative d-flex align-items-center justify-content-center w-100`}
      >
        <picture>
          <source srcSet={`/assets/menu/icon_settings.webp`} type="image/webp" />
          <img style={{ height: '50px' }} src={`/assets/menu/icon_settings.png`} alt="Settings" />
        </picture>

        <span>
          {translate('menu_settings')}
        </span>

        {indicators?.settingsIndicator && (
          <span className="position-absolute translate-middle bg-danger rounded-circle" style={{
            top: '20px',
            left: '61%',
            width: '10px',
            height: '10px'
          }}></span>
        )}
      </button>
    </div>
  );
};


